// Dauer der Zeiterfassung lesen und zeigen (ohne Oberfläche, auch im Server-Test): gespeichert werden ganze Minuten,
// 1 Minute bis 24 Stunden wie auf dem Server (zeiten.ts). Angezeigt wird überall Stunden:Minuten („1:30 Std.“).

export const MINUTEN_MAX = 24 * 60;

// „1:30“, „1,5“, „1.5“, „90 min“, „2 h“, „2 Std.“, „8“ (Stunden) → Minuten; unlesbar, 0 oder über 24 Stunden: null
export function dauerLesen(text: string): number | null {
  const t = text.trim().toLowerCase().replace(/\s+/g, ' ');
  if (!t) return null;
  let m: number | null = null;
  const hm = /^(\d{1,2}):(\d{2})( ?(h|std\.?))?$/.exec(t);
  const min = /^(\d{1,4}) ?(min|minuten)\.?$/.exec(t);
  const std = /^(\d{1,2})([.,](\d{1,2}))? ?(h|std\.?|stunden)?$/.exec(t);
  if (hm) {
    const minuten = Number(hm[2]);
    if (minuten > 59) return null;
    m = Number(hm[1]) * 60 + minuten;
  } else if (min) {
    m = Number(min[1]);
  } else if (std) {
    m = Math.round(Number(`${std[1]}.${std[3] ?? '0'}`) * 60);
  }
  return m !== null && m >= 1 && m <= MINUTEN_MAX ? m : null;
}

// 90 → „1:30“
export const dauerText = (minuten: number) => `${Math.floor(minuten / 60)}:${String(minuten % 60).padStart(2, '0')}`;
// 90 → „1:30 Std.“
export const stundenText = (minuten: number) => `${dauerText(minuten)} Std.`;

// Hilfe „von–bis minus Pause“ (rechnet nur im Browser, gespeichert wird die Dauer): „07:30“ bis „16:00“ mit 30 Minuten
// Pause → 480; über Mitternacht zählt bis am nächsten Tag. Nichts lesbar oder keine Dauer übrig: null
export function vonBis(von: string, bis: string, pause: number): number | null {
  const lesen = (s: string) => {
    const x = /^(\d{1,2}):(\d{2})$/.exec(s.trim());
    return x && Number(x[1]) < 24 && Number(x[2]) < 60 ? Number(x[1]) * 60 + Number(x[2]) : null;
  };
  const a = lesen(von);
  const b = lesen(bis);
  if (a === null || b === null || a === b || !Number.isFinite(pause) || pause < 0) return null;
  const m = (b > a ? b - a : b + MINUTEN_MAX - a) - Math.round(pause);
  return m >= 1 ? m : null;
}
